// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMToast.tsx — PropelMapper transient feedback.
//
// Three exports that work together:
//   • PMToast         — a single presentational toast row (also usable on its own).
//   • PMToastViewport — a fixed-position, edge-anchored stack that renders an array
//                       of toasts, handles enter/leave animation, auto-dismiss, and
//                       pause-on-hover. It is the aria-live region.
//   • usePMToasts     — a hook that owns the toast array + push/dismiss/clear and the
//                       auto-dismiss + exit timers. The imperative API consumers use.
//
// System rules honored: status palette (success/error/info/warning) via --pm-*
// tokens; NO colored left-border accent (PropelMapper bans those) — the status
// signal is a colored disc + glyph instead; success/info announce politely,
// error/warning assertively; motion respects prefers-reduced-motion.
//
// Typical wiring:
//   const { toasts, push, dismiss } = PM.usePMToasts();
//   <PMToastViewport toasts={toasts} onDismiss={dismiss} placement="bottom-right" />
//   push({ variant: "success", title: "Visit synced", message: "3 observations uploaded." });

const PMTOAST_CSS = `
.pmtoast-vp{position:fixed;z-index:var(--pmtoast-z,1000);display:flex;flex-direction:column;gap:10px;padding:20px;max-width:100vw;pointer-events:none;box-sizing:border-box}
.pmtoast-vp--bottom-right{right:0;bottom:0;align-items:flex-end}
.pmtoast-vp--bottom-left{left:0;bottom:0;align-items:flex-start}
.pmtoast-vp--bottom-center{left:50%;bottom:0;transform:translateX(-50%);align-items:center}
.pmtoast-vp--top-right{right:0;top:0;align-items:flex-end}
.pmtoast-vp--top-left{left:0;top:0;align-items:flex-start}
.pmtoast-vp--top-center{left:50%;top:0;transform:translateX(-50%);align-items:center}

.pmtoast{box-sizing:border-box;pointer-events:auto;width:380px;max-width:calc(100vw - 40px);display:flex;align-items:flex-start;gap:12px;background:var(--pm-surface);border:1px solid var(--pm-border-light);border-radius:var(--pm-radius-l,12px);box-shadow:var(--pm-shadow-lg,0 10px 30px rgba(0,0,0,.12));padding:14px 14px 14px 14px;font-family:var(--pm-font-sans);color:var(--pm-fg-1)}
.pmtoast-ico{flex:0 0 26px;width:26px;height:26px;border-radius:50%;display:grid;place-items:center;color:#fff;margin-top:1px}
.pmtoast--success .pmtoast-ico{background:var(--pm-success)}
.pmtoast--error .pmtoast-ico{background:var(--pm-error)}
.pmtoast--info .pmtoast-ico{background:var(--pm-info)}
.pmtoast--warning .pmtoast-ico{background:var(--pm-warning)}
.pmtoast-ico svg{display:block}
.pmtoast-body{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}
.pmtoast-title{font:600 14px/1.35 var(--pm-font-sans);color:var(--pm-fg-1);letter-spacing:-.1px}
.pmtoast-msg{font:400 13px/1.45 var(--pm-font-sans);color:var(--pm-fg-2);text-wrap:pretty}
.pmtoast-action{align-self:flex-start;margin-top:7px;background:transparent;border:none;padding:0;cursor:pointer;font:700 13px/1 var(--pm-font-sans);color:var(--pm-primary);border-radius:4px}
.pmtoast-action:hover{color:var(--pm-primary-dark);text-decoration:underline}
.pmtoast-action:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmtoast-x{flex:0 0 24px;width:24px;height:24px;margin:-3px -3px 0 0;display:grid;place-items:center;border:none;background:transparent;cursor:pointer;border-radius:6px;color:var(--pm-fg-3)}
.pmtoast-x:hover{background:var(--pm-surface-variant);color:var(--pm-fg-1)}
.pmtoast-x:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmtoast-x svg{display:block}

.pmtoast--entering{animation:pmtoastIn 220ms cubic-bezier(0.32,0.72,0,1)}
.pmtoast-vp--top-right .pmtoast--entering,.pmtoast-vp--top-left .pmtoast--entering,.pmtoast-vp--top-center .pmtoast--entering{animation-name:pmtoastInTop}
.pmtoast.is-leaving{animation:pmtoastOut 180ms ease forwards}
@keyframes pmtoastIn{from{opacity:0;transform:translateY(16px) scale(.98)}to{opacity:1;transform:none}}
@keyframes pmtoastInTop{from{opacity:0;transform:translateY(-16px) scale(.98)}to{opacity:1;transform:none}}
@keyframes pmtoastOut{to{opacity:0;transform:scale(.97);margin-top:-8px}}
@media (prefers-reduced-motion: reduce){.pmtoast--entering,.pmtoast.is-leaving{animation:none!important}}
`;

function pmtoastEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmtoast-css")) return;
  const s = document.createElement("style"); s.id = "pmtoast-css"; s.textContent = PMTOAST_CSS;
  document.head.appendChild(s);
}

function PMToastGlyph({ variant }: any) {
  const common = { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", "aria-hidden": true } as any;
  if (variant === "success")
    return <svg {...common}><path d="M5 13l4 4 10-10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>;
  if (variant === "error")
    return <svg {...common}><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /></svg>;
  if (variant === "warning")
    return <svg {...common}><path d="M12 7v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /><circle cx="12" cy="17" r="1.4" fill="currentColor" /></svg>;
  // info
  return <svg {...common}><path d="M12 11v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /><circle cx="12" cy="7" r="1.4" fill="currentColor" /></svg>;
}

function PMToastCloseGlyph() {
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>;
}

export function PMToast({
  variant = "info",
  title,
  message,
  action = null,
  onClose,
  icon = undefined,
  leaving = false,
  animateIn = false,
  showClose = true,
  className = "",
  style = {},
  ...rest
}: any) {
  pmtoastEnsureCSS();
  // Base style is the visible end-state (opacity:1). The entrance animation has NO
  // fill-mode and is applied only to toasts mounted through PMToastViewport
  // (animateIn). Static specimens never animate, and because there's no `both`/
  // `forwards`, any context where the animation clock is frozen (DS thumbnail,
  // screenshot/PDF export, throttled tab) falls back to the visible base style.
  const assertive = variant === "error" || variant === "warning";
  return (
    <div
      className={"pmtoast pmtoast--" + variant + (animateIn && !leaving ? " pmtoast--entering" : "") + (leaving ? " is-leaving" : "") + (className ? " " + className : "")}
      role={assertive ? "alert" : "status"}
      aria-live={assertive ? "assertive" : "polite"}
      style={style}
      {...rest}
    >
      <span className="pmtoast-ico">{icon !== undefined ? icon : <PMToastGlyph variant={variant} />}</span>
      <div className="pmtoast-body">
        {title ? <div className="pmtoast-title">{title}</div> : null}
        {message ? <div className="pmtoast-msg">{message}</div> : null}
        {action ? (
          <button type="button" className="pmtoast-action" onClick={action.onClick}>{action.label}</button>
        ) : null}
      </div>
      {showClose ? (
        <button type="button" className="pmtoast-x" aria-label="Dismiss" onClick={onClose}><PMToastCloseGlyph /></button>
      ) : null}
    </div>
  );
}

export function PMToastViewport({
  toasts = [],
  onDismiss,
  placement = "bottom-right",
  max = 4,
  zIndex = 1000,
}: any) {
  pmtoastEnsureCSS();
  const list = max ? toasts.slice(-max) : toasts;
  // Newest nearest the anchored edge: bottom placements render reversed so the
  // latest sits at the bottom; top placements keep insertion order.
  const ordered = placement.indexOf("bottom") === 0 ? list : list;
  return (
    <div
      className={"pmtoast-vp pmtoast-vp--" + placement}
      style={{ ["--pmtoast-z" as any]: zIndex }}
      aria-live="polite"
      aria-relevant="additions"
    >
      {ordered.map((t: any) => (
        <PMToast
          key={t.id}
          variant={t.variant}
          title={t.title}
          message={t.message}
          action={t.action}
          icon={t.icon}
          leaving={t.leaving}
          animateIn={true}
          showClose={t.showClose !== false}
          onClose={() => onDismiss && onDismiss(t.id)}
          onMouseEnter={() => t.onPause && t.onPause()}
          onMouseLeave={() => t.onResume && t.onResume()}
        />
      ))}
    </div>
  );
}

export function usePMToasts(opts: any = {}) {
  const defaultDuration = opts.duration != null ? opts.duration : 5000;
  const exitMs = opts.exitMs != null ? opts.exitMs : 200;
  const [toasts, setToasts] = (React as any).useState([]);
  const timers = (React as any).useRef({});
  const idRef = (React as any).useRef(0);

  const clearTimer = (id: any) => { if (timers.current[id]) { clearTimeout(timers.current[id]); delete timers.current[id]; } };

  const remove = (React as any).useCallback((id: any) => {
    clearTimer(id);
    // mark leaving, then unmount after the exit animation
    setToasts((cur: any) => cur.map((t: any) => (t.id === id ? { ...t, leaving: true } : t)));
    setTimeout(() => setToasts((cur: any) => cur.filter((t: any) => t.id !== id)), exitMs);
  }, [exitMs]);

  const scheduleAuto = (React as any).useCallback((id: any, duration: any) => {
    if (!duration) return; // 0 / null = sticky
    clearTimer(id);
    timers.current[id] = setTimeout(() => remove(id), duration);
  }, [remove]);

  const push = (React as any).useCallback((t: any) => {
    const id = t && t.id != null ? t.id : "pmt-" + (++idRef.current);
    const duration = t && t.duration !== undefined ? t.duration : defaultDuration;
    const entry = {
      id,
      variant: "info",
      ...t,
      leaving: false,
      onPause: () => clearTimer(id),
      onResume: () => scheduleAuto(id, duration),
    };
    setToasts((cur: any) => [...cur, entry]);
    scheduleAuto(id, duration);
    return id;
  }, [defaultDuration, scheduleAuto]);

  const clear = (React as any).useCallback(() => {
    Object.keys(timers.current).forEach(clearTimer);
    setToasts([]);
  }, []);

  (React as any).useEffect(() => () => { Object.keys(timers.current).forEach(clearTimer); }, []);

  return { toasts, push, dismiss: remove, clear };
}
